// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_RetrocederEtapaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/orders/retroceder_etapa/{order_item_id}
 *
 * Moves a service item back to its previous production step (chamado
 * 2026-0027). The `motivo` is mandatory — it is what the audit row in
 * so_production_logs carries, and a step rollback without a reason is
 * indistinguishable from a mis-scan.
 */
import { registerContract } from './validate'

export interface Orders_RetrocederEtapaInput {
motivo?: string
}

registerContract('Orders_RetrocederEtapaInput', {
  motivo: { type: 'string',  required: false },
})
